// extracted by mini-css-extract-plugin
export default {"root":"CheckboxWithLabel_root__uYOfc","label":"CheckboxWithLabel_label__Y+IP8"};